// Vue, Vuex, Router and Axios
import Vue from "vue"
import Vuex from 'vuex'
import VueRouter from "vue-router"
import axios from 'axios'
import './directives/index.js';
import VeeValidate, {Validator} from 'vee-validate'
import attributesEs from 'vee-validate/dist/locale/es'
import Loading from 'vue-loading-overlay';
import BootstrapVue from 'bootstrap-vue'
import VueNumeric from 'vue-numeric'


// Custom CSS
require('normalize.css');
require('../css/app.css');
require('../css/fonts.css');
import 'vue-loading-overlay/dist/vue-loading.css';
// Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

require('../css/element-ui-theme/index.css');
window.CryptoJS = require("crypto-js");

import locale from 'element-ui/lib/locale/lang/es';


import './utils/filters.js';

import IdleVue from 'idle-vue'

const eventsHub = new Vue();

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: 1000000
});
// Font Awesome Icons
require('../css/pro/css/fontawesome-all.css');
require('../css/font-awesome/css/fontawesome-all.min.css');
import 'animate.css'

// Moment JS with Spanish Translation
import moment from 'moment';

require('moment/locale/es');
// Animate.css
import 'animate.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-loading-overlay/dist/vue-loading.css';

import htmlDocx from 'html-docx-js/dist/html-docx'

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(ElementUI, {locale});
Vue.use(require('vue-moment'));
Vue.use(VueNumeric);


window.Vue = Vue;
window.axios = axios;
window._ = require('lodash');
window.$ = window.jQuery = require('jquery');

require("jquery-ui");
require('./resources/jquery.timers/jquery.timers');
window.moment = moment;
window.htmlDocx = htmlDocx;



window.versionApp = 'v. 3.4.7';



window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json',
    'Accept-C': window.acceptC
};

window.jsPDF = require('jspdf');


Validator.localize('es', attributesEs);

Vue.use(VeeValidate, {
    locale: 'es',
    errorBagName: 'validations',
    fieldsBagName: 'inputs',
    dictionary: {
        translationsEs: {attributes: attributesEs}
    }
});
Vue.use(Loading);
Vue.component('loading', Loading);
Vue.use(BootstrapVue);
require('./directives/index.js');
require('./directives/tooltip.js');
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-loading-overlay/dist/vue-loading.css';



window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/json',
    'Accept-C': window.acceptC
};

if (window.sessionStorage.getItem('sipac_token')) {
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.sessionStorage.getItem('sipac_token');
}

